import { Inject } from '@angular/core';
import '@angular/compiler';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageAdminUsersComponent } from './page.admin.users/page.admin.users.component';
import { PageAdminMaterialsComponent } from './page.admin.materials/page.admin.materials.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageMainComponent } from './page.main/page.main.component';
import { PagePendingComponent } from './page.pending/page.pending.component';
import { PageHomeComponent } from './page.home/page.home.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { PageSignupComponent } from './page.signup/page.signup.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageAdminLibraryComponent } from './page.admin.library/page.admin.library.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageAdminMaterialsDetailComponent } from './page.admin.materials.detail/page.admin.materials.detail.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageAdminMaterialsNewComponent } from './page.admin.materials.new/page.admin.materials.new.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageAdminResourcesComponent } from './page.admin.resources/page.admin.resources.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PortalSeasonPaginationComponent,
        PageAdminUsersComponent,
        PageAdminMaterialsComponent,
        PortalSeasonModalComponent,
        PageMainComponent,
        PagePendingComponent,
        PageHomeComponent,
        PageLoginComponent,
        PageSignupComponent,
        LayoutEmptyComponent,
        PageAdminLibraryComponent,
        PortalSeasonLoadingDefaultComponent,
        PortalSeasonTreeComponent,
        PageAdminMaterialsDetailComponent,
        PortalSeasonFormDropdownComponent,
        PageAdminMaterialsNewComponent,
        PortalSeasonLoadingSeasonComponent,
        PageAdminResourcesComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }